class CollectionPriceSlider extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('.collection-range-input--min');
    this.maxInput = this.querySelector('.collection-range-input--max');
    this.fill = this.querySelector('.collection-range-fill');
    this.minValue = this.querySelector('.collection-range-value--min');
    this.maxValue = this.querySelector('.collection-range-value--max');
    this.symbol = this.minValue ? this.minValue.textContent.trim().replace(/[\d.,\s]/g, '') : '';

    const scope = this.closest('.facets__display-vertical') || this.closest('.mobile-facets__submenu');
    const fields = scope ? scope.querySelectorAll('price-range input') : [];
    this.fieldMin = fields[0];
    this.fieldMax = fields[1];

    this.addEventListener('input', this.onSlide.bind(this));
    this.addEventListener('change', this.onCommit.bind(this));
    this.render();
  }

  get max() {
    return Number(this.dataset.max || 0);
  }

  onSlide(event) {
    const min = Number(this.minInput.value);
    const max = Number(this.maxInput.value);

    if (min > max) {
      if (event.target === this.minInput) {
        this.minInput.value = max;
      } else {
        this.maxInput.value = min;
      }
    }

    this.render();
    event.stopPropagation();
  }

  onCommit(event) {
    event.stopPropagation();

    const min = Number(this.minInput.value);
    const max = Number(this.maxInput.value);

    if (this.fieldMin) this.fieldMin.value = min > 0 ? min : '';
    if (this.fieldMax) this.fieldMax.value = max < this.max ? max : '';

    const target = this.fieldMax || this.fieldMin;
    if (target) target.dispatchEvent(new Event('input', { bubbles: true }));
  }

  render() {
    if (!this.max) return;

    const min = Number(this.minInput.value);
    const max = Number(this.maxInput.value);
    const start = (min / this.max) * 100;
    const end = (max / this.max) * 100;

    this.fill.style.left = `${start}%`;
    this.fill.style.right = `${100 - end}%`;
    this.minValue.textContent = `${this.symbol}${min}`;
    this.maxValue.textContent = `${this.symbol}${max}`;
  }
}

if (!customElements.get('collection-price-slider')) {
  customElements.define('collection-price-slider', CollectionPriceSlider);
}

class CollectionSortDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.collection-sort-toggle');
    this.current = this.querySelector('[data-sort-current]');
    this.options = this.querySelectorAll('.collection-sort-option');
    this.select = this.closest('.facet-filters__field').querySelector('.facet-filters__sort');

    this.toggle.addEventListener('click', () => this.toggleOpen());
    this.options.forEach((option) => option.addEventListener('click', () => this.onOptionClick(option)));
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.close();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.close();
      this.toggle.focus();
    });
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  toggleOpen() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
  }

  onOptionClick(option) {
    this.close();
    if (!this.select || option.dataset.value === this.select.value) return;

    this.select.value = option.dataset.value;
    this.current.textContent = option.textContent.trim();
    this.options.forEach((item) => {
      const selected = item === option;
      item.classList.toggle('is-active', selected);
      item.closest('[role="option"]').setAttribute('aria-selected', selected);
    });
    this.select.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('collection-sort-dropdown')) {
  customElements.define('collection-sort-dropdown', CollectionSortDropdown);
}

const bindCollectionFilterTriggers = () => {
  const triggers = document.querySelectorAll('.collection-filter-trigger');

  triggers.forEach((trigger) => {
    if (trigger.dataset.filterBound) return;
    trigger.dataset.filterBound = 'true';

    trigger.addEventListener('click', () => {
      const summary = document.querySelector(
        '#main-collection-filters .mobile-facets__open-wrapper, #main-search-filters .mobile-facets__open-wrapper'
      );
      if (summary) summary.click();
    });
  });
};

window.bindCollectionFilterTriggers = bindCollectionFilterTriggers;

document.addEventListener('DOMContentLoaded', () => {
  bindCollectionFilterTriggers();

  const drawerDisclosure = document.querySelector(
    '#main-collection-filters .mobile-facets__disclosure, #main-search-filters .mobile-facets__disclosure'
  );

  if (drawerDisclosure) {
    drawerDisclosure.addEventListener('toggle', () => {
      if (!drawerDisclosure.open) return;

      const filterGroups = drawerDisclosure.querySelectorAll('.mobile-facets__details');
      filterGroups.forEach((details) => details.setAttribute('open', ''));
    });
  }

  const drawerOverlay = document.getElementById('FacetFiltersFormMobile');

  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', (event) => {
      if (event.target !== drawerOverlay) return;

      const summary = document.querySelector('#main-collection-filters .mobile-facets__open-wrapper');
      if (summary) summary.click();
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ProductGridContainer');
  if (!container || !container.closest('.collection-infinite')) return;

  const layout = container.closest('.collection-page-layout') || container;
  const sentinel = document.createElement('div');
  sentinel.className = 'collection-infinite-sentinel';
  layout.after(sentinel);

  let loading = false;

  const loadNextPage = () => {
    const nextLink = container.querySelector('.pagination-wrapper a[rel="next"]');
    if (!nextLink || loading) return;

    loading = true;
    sentinel.classList.add('is-loading');

    fetch(nextLink.href)
      .then((response) => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const grid = document.getElementById('product-grid');
        const newGrid = doc.getElementById('product-grid');

        if (grid && newGrid) {
          [...newGrid.children].forEach((item) => {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            grid.appendChild(item);
          });
        }

        const wrapper = container.querySelector('.pagination-wrapper');
        const newWrapper = doc.querySelector('.pagination-wrapper');
        if (wrapper && newWrapper) {
          wrapper.replaceWith(newWrapper);
        } else if (wrapper) {
          wrapper.remove();
        }

        const count = document.getElementById('ProductCountDesktop');
        const newCount = doc.getElementById('ProductCountDesktop');
        if (count && newCount) {
          count.textContent = newCount.textContent.trim().replace(/\d+/, '1');
        }
      })
      .finally(() => {
        loading = false;
        sentinel.classList.remove('is-loading');
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) loadNextPage();
    },
    { rootMargin: '400px 0px' }
  );

  observer.observe(sentinel);

  const loadWhenNear = () => {
    if (sentinel.getBoundingClientRect().top - window.innerHeight < 400) loadNextPage();
  };

  window.addEventListener('scroll', loadWhenNear, { passive: true });
  window.addEventListener('resize', loadWhenNear, { passive: true });
});
